// Added new edge type 2 - gray color with no title/label
import { getSmoothStepPath } from '@xyflow/react';

export const NoTitleEdge2 = ({ id, sourceX, sourceY, targetX, targetY }: any) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY
  });

  return (
    <>
      {/* Marker definition must be in the DOM */}
      <svg style={{ height: 0 }}>
        <defs>
          <marker
            id="notitle2-arrow"
            markerWidth="10"
            markerHeight="8"
            viewBox="0 0 10 8"
            refX="10"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 4 L 0 8 z" fill="#808080" />
          </marker>
        </defs>
      </svg>

      {/* Edge path with arrow marker */}
      <path
        id={id}
        d={edgePath}
        className="react-flow__edge-path"
        style={{ stroke: '#808080', strokeWidth: 2 }}
        fill="none"
        markerEnd="url(#notitle2-arrow)"
      />
      {/* No label renderer - edge has no title */}
    </>
  );
};
